global.api_url = "https://5za430piak.execute-api.eu-central-1.amazonaws.com/api/td";
global.env = "production";
